/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const getPDPSeoDetails = (product, category) => {
  if (category === 'fruits_primary' || category === 'vegetables_primary' || category === 'meat_and_seafood') {
    return {
      title: `Buy Fresh ${product?.name} Online at ₹${product?.sellingPrice} - LoveLocal`,
      description: `Order ${product?.name} online in Mumbai from trusted local shops. Best prices, free home delivery* & guaranteed freshness with LoveLocal.`
    }
  }

  return {
    title: `Buy ${product?.name} Online at ₹${product?.sellingPrice} - LoveLocal`,
    description: `Order ${product?.name} online in Mumbai from trusted local shops. Best prices and free home delivery* with LoveLocal.`
  }
}

export const getPLPSeoDetails = (store, category) => {
  if (category === 'Fruits & Vegetables Shops' || category === 'Meat & Fish Shops') {
    return {
      title: `Order  ${category} Online in ${store?.storeData?.locality} - ${store?.storeData?.storeName}`,
      description: `Order ${category} online from ${store?.storeData?.storeName} in ${store?.storeData?.locality} via LoveLocal. Quick delivery✅, top deals✅ and guaranteed freshness✅`
    }
  } else if (category === 'Groceries') {
    return {
      title: `Order ${category} Online from Nearby Local Store in ${store?.storeData?.locality}`,
      description: `Discover nearby grocery stores and order essentials online from trusted local shops in ${store?.storeData?.locality}. Fast delivery✅, fresh products ✅, and convenient shopping anytime.`
    }
  } else if (category === 'Sweets & Farsan Shops') {
    return {
      title: `Order ${category} Online from Nearby Local Store in ${store?.storeData?.locality}`,
      description: `Discover nearby sweets and farsan shops and order your favourites online from trusted local stores in ${store?.storeData?.locality}. Fresh mithai ✅ authentic farsan ✅ and free home delivery.`
    }
  } else if (category === 'Dairies') {
    return {
      title: `Order ${category} Online from Nearby Local Store in ${store?.storeData?.locality}`,
      description: `Discover nearby dairy shops and order fresh milk, curd, paneer, ghee, and more from trusted local stores in ${store?.storeData?.locality}. Pure dairy products ✅ quick delivery ✅ and guaranteed freshness.`
    }
  } else {
    return {
      title: `Order Grocery Online from Nearby Local Store in ${store?.storeData?.locality}`,
      description: `Discover nearby grocery stores and order essentials online from trusted local shops in ${store?.storeData?.locality}. Fast delivery✅, fresh products ✅, and convenient shopping anytime.`
    }
  }
}
